var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 34.652 34.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M71.838,0A17.326,17.326,0,1,0,89.164,17.326,17.291,17.291,0,0,0,71.838,0m8.645,17.326v1.256c-.993,0-3.883,1.254-7,3.353-3.717,2.5-4.919,4.269-4.919,4.733H66.05V7.983h2.512c0,.464,1.2,2.231,4.919,4.733,3.118,2.1,6.008,3.353,7,3.353Z",
    transform: "translate(-54.512)",
    fill: "#001233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.0fd0c37994cda184c65ec583e221869c.svg";
export { ForwardRef as ReactComponent };